import { render } from "./DeletedAppointmentDays.vue?vue&type=template&id=a613beb2&scoped=true"
import script from "./DeletedAppointmentDays.vue?vue&type=script&lang=js"
export * from "./DeletedAppointmentDays.vue?vue&type=script&lang=js"

import "./DeletedAppointmentDays.vue?vue&type=style&index=0&id=a613beb2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a613beb2"]])

export default __exports__